import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class JourneyPlannerMapService {
    private isFullMapView = new BehaviorSubject(false);
    public isFullMapView$ = this.isFullMapView.asObservable();

    setViewMap(value: boolean) {
        this.isFullMapView.next(value);
    }

    toggleViewMap() {
        this.isFullMapView.next(!this.isFullMapView.value);
    }

    valueMapView() {
        return this.isFullMapView.value;
    }
}
